import {Component, OnDestroy, OnInit} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {AlertController} from "ionic-angular";
import {User} from "../../../shared/user/user.model";
import {ProfileService} from "../../../profile/profile.service";
import {AppAuth} from "../../../../app/core/auth";
import {JobService} from "../../../job/shared/job.service";

@Component({
  selector: 'app-client-jobs-filters',
  template: `
    <ion-list>
      <ion-item>
        <button ion-button clear small item-end icon-end (click)="openUserFilter()">
          <span *ngIf="selectedOption">{{ selectedOption.label }}</span>
          <ion-icon name="arrow-dropdown"></ion-icon>
        </button>
      </ion-item>
    </ion-list>
  `
})
export class ClientJobsFiltersComponent implements OnInit, OnDestroy{

  users: User[];
  state: { user_id: number };
  stateSub: any;
  selectedOption = null;

  constructor(private translate: TranslateService,
              private alertCtrl: AlertController,
              private profileService: ProfileService,
              private auth: AppAuth,
              private jobService: JobService
  ) {
  }

  ngOnInit(){
    this.profileService.getOrganisationUsers()
      .map(users => users.filter(user => user.id !== this.auth.user.sub))
      .subscribe(users => {
        this.users = users;

        this.stateSub = this.jobService.getCollectionState()
          .subscribe(state => {
            this.state = state;
            this.selectedOption = this.getChecked(this.prepareOptions())
          });
      });
  }

  ngOnDestroy(){
    this.stateSub && this.stateSub.unsubscribe();
  }

  openUserFilter() {
    // Create modal
    let alert = this.alertCtrl.create({inputs: this.prepareOptions()})
      .setTitle(this.translate.instant('jobs.filter_by_user'))
      .addButton(this.translate.instant('global.cancel'))
      .addButton({
        text: this.translate.instant('global.apply'),
        handler: (res) => {
          alert.dismiss()
            .then(() => this.jobService.updateCollectionState({user_id: res}));
          return false;
        }
      });

    alert.present();
  }

  private getChecked(options){
    return options.find(option => option.checked === true);
  }

  private prepareOptions(){
    // Create options
    let options = [];
    if(this.auth.user){
      options.push({
        type: 'radio',
        label: this.translate.instant('jobs.my_jobs'),
        value: this.auth.user.sub
      });
    }
    options.push({
      type: 'radio',
      label: this.translate.instant('jobs.everyone'),
      value: ''
    });
    this.users.forEach(user => options.push({
      type: 'radio',
      label: user.name,
      value: String(user.id)
    }));

    // Select option
    options.forEach(option => {
      option['checked'] = option.value == this.state.user_id;
      return option;
    });

    return options;
  }

}



// WEBPACK FOOTER //
// ./src/pages/jobs-list/shared/client-jobs-filters/client-jobs-filters.component.ts